import { AnyAction } from "redux"
import { ThunkAction } from "redux-thunk"
import { requestThunk } from "swiipe.portal.shared"
import { endpoints } from "../../data/endpoints"
import { IInstallationRequestDto } from "../../type/installation/debugInstallationTypes"
import { IInstallationDto } from "../../type/installation/installationTypes"
import { StoreState } from "../StoreState"
import { debugInstallationActions, debugInstallationSelectors } from "../reducers/debugInstallationSlice"

export const ensureDebugInstallationsThunk =
    (swMerchantId: string, force: boolean): ThunkAction<Promise<void>, StoreState, null, AnyAction> =>
    async (dispatch, getState) => {
        const installations = debugInstallationSelectors.installations(getState(), swMerchantId)
        if (!force && installations) {
            return
        }
        const resp = await dispatch(
            requestThunk<{ installations: IInstallationDto[] }>(endpoints.Plugin.getDebugInstallations, {
                params: {
                    swMerchantId,
                },
            })
        )

        dispatch(
            debugInstallationActions.setDebugInstallations({ installations: resp.installations, swMerchantId: swMerchantId })
        )
    }

export const getDebugInstallationRequestsThunk =
    (installationId: string): ThunkAction<Promise<void>, StoreState, null, AnyAction> =>
    async (dispatch, getState) => {
        dispatch(debugInstallationActions.setDebugInstallationRequests({ requests: undefined, installationId: installationId }))
        const resp = await dispatch(
            requestThunk<{ requests: IInstallationRequestDto[] }>(endpoints.Plugin.getDebugRequests, {
                params: {
                    installationId,
                },
            })
        )

        dispatch(
            debugInstallationActions.setDebugInstallationRequests({ requests: resp.requests, installationId: installationId })
        )
    }

export const cleanupDebugInstallationRequestsThunk =
    (installationId: string): ThunkAction<Promise<void>, StoreState, null, AnyAction> =>
    async (dispatch, getState) => {
        dispatch(debugInstallationActions.setDebugInstallationRequests({ requests: undefined, installationId: installationId }))
        await dispatch(
            requestThunk(endpoints.Plugin.cleanupDebugRequests, {
                params: {
                    installationId,
                    deleteUntil: new Date().toISOString(),
                },
            })
        )

        await dispatch(getDebugInstallationRequestsThunk(installationId))
    }

export const enableInstallationDebugThunk =
    (
        swMerchantId: string,
        installationId: string,
        minutes: number,
        sessionId: string
    ): ThunkAction<Promise<void>, StoreState, null, AnyAction> =>
    async (dispatch, getState) => {
        await dispatch(
            requestThunk(endpoints.Plugin.enableDebug, {
                data: {
                    installationId,
                    sessionId,
                    minutesEnabled: minutes,
                },
            })
        )

        await dispatch(ensureDebugInstallationsThunk(swMerchantId, true))
    }

export const cacheClearThunk =
    (cacheType: string, cacheKey: string): ThunkAction<Promise<void>, StoreState, null, AnyAction> =>
    async (dispatch, getState) => {
        await dispatch(requestThunk(endpoints.Content.cacheClear(cacheType, cacheKey)))
    }
